import { formatNumber } from "accounting"
import { Flex, Tag, Typography } from "antd"
import dayjs from "dayjs"

import Private from "../../../../Components/Private"
import Icon from "../../../../Icon"
import { dateFormat } from "../../../../Utils/utils"
import { CHANNEL_META, PROGRAM_CARD_META } from "../../constants/receipt-status-mapping"

import styles from "./styles.module.less"

const { Text } = Typography

const ReceiptLookupCard = ({ record }) => {
  const program = PROGRAM_CARD_META[record.program]
  const channel = CHANNEL_META[record.channel]

  return (
    <Flex
      vertical
      gap={8}
      className={styles.card}
      data-testid={`deflect-user-lookup-card-${record.id}`}
    >
      <Flex justify="space-between" align="center">
        <Text strong>{dayjs(record.date).format(dateFormat)}</Text>
        {program && (
          <Flex justify={"center"} gap={4}>
            {program?.iconType && (
              <Icon type={program.iconType} style={{ fontSize: 20, lineHeight: 1 }} />
            )}
            <Text strong>{program?.label}</Text>
          </Flex>
        )}
      </Flex>
      <Flex justify="space-between" align="center">
        <Text type="secondary">{record.card ? <Private>{record.card}</Private> : "—"}</Text>
        <Text strong>
          <Private>${formatNumber(record.amount ?? 0, 2, ",")}</Private>
        </Text>
      </Flex>
      <Flex justify="space-between" align="center">
        {channel ? (
          <Tag color={channel.color} style={{ margin: 0 }}>
            {channel.label}
          </Tag>
        ) : (
          <span />
        )}
        <Text type="secondary" style={{ fontSize: 12 }}>
          Fee <Private>${formatNumber(record.fee_charged ?? 0, 2, ",")}</Private>
        </Text>
      </Flex>
    </Flex>
  )
}

export default ReceiptLookupCard
